const errorWithCaptureStackTrace = Error;
export class ExtendableError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = new.target.name;
        if (typeof errorWithCaptureStackTrace.captureStackTrace === 'function') {
            errorWithCaptureStackTrace.captureStackTrace(this, new.target);
        }
    }
}
